// @flow
import React, { PureComponent } from 'react';
import { View, ScrollView, StyleSheet, RefreshControl } from 'react-native';
import { withNavigation } from '@react-navigation/compat';

import { PlanSummary } from '../../../../components/common';
import I18n from '../../../../lib/i18n';
import theme from '../../../../theme-config';
import { InternationalHeader, TwoColumnsList } from '../../../../components/international';
import RoamingFooter from '../RoamingFooter';

import type { CountryType } from '../../../../config/iddCountries';
import type { Option } from 'digicel-kaizen-library';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';

class RoamingPackage extends PureComponent<Props> {
  styles = getStyles();

  getMoreInformation = () => [
    {
      title: I18n.t('RoamingOffer.RoamingPackage.validity'),
      text: I18n.t('RoamingOffer.RoamingPackage.validityDescription'),
    },
    {
      title: I18n.t('RoamingOffer.RoamingPackage.renewal'),
      text: I18n.t('RoamingOffer.RoamingPackage.renewalDescription'),
    },
    {
      title: I18n.t('RoamingOffer.RoamingPackage.more'),
      text: I18n.t('RoamingOffer.RoamingPackage.moreDescription'),
    },
  ];

  render() {
    const styles = this.styles;

    return (
      <View style={styles.container}>
        <ScrollView
          refreshControl={
            <RefreshControl onRefresh={this.props.fetchRoamingBundles} refreshing={this.props.isLoading} />
          }
        >
          <InternationalHeader
            iconName="paper-plane"
            iconColor={theme.roamingIconColor}
            image={theme.roamingPackOfferImage}
            imageStyle={{
              width: 85,
              height: 94,
              resizeMode: 'contain',
              marginHorizontal: 15,
            }}
            title={I18n.t('RoamingOffer.RoamingPackage.offerName', { zone: this.props.roamingCountryZone })}
            textLine1={
              this.props.route.params?.comesFromDashboard
                ? I18n.t('RoamingOffer.RoamingPackage.enables')
                : this.props.roamingCountryId &&
                  I18n.t('RoamingOffer.RoamingPackage.enablesOutOf', {
                    country: I18n.t(`countries.${this.props.roamingCountryId}`),
                  })
            }
            linkText={I18n.t('RoamingOffer.eligibleCountries')}
            countryList={this.props.roamingGroupCountries}
          />
          <View style={styles.planSummary}>
            <PlanSummary options={{ creditable: this.props.options, service: [] }} inversedColors />
          </View>
          {this.getMoreInformation()
            .filter(info => info)
            .map(info => (
              <TwoColumnsList key={info.title} title={info.title} text={info.text} />
            ))}
        </ScrollView>
        <RoamingFooter
          price={this.props.price}
          orderLabel={I18n.t('RoamingOffer.RoamingPackage.yourPlan')}
          onConfirm={this.props.buy}
          confirmText={I18n.t('RoamingOffer.RoamingPackage.confirmButton')}
          disabled={!this.props.canBuy}
          isExemptedFromTax={this.props.isExemptedFromTax}
          isLoading={this.props.isConfirmationLoading}
        />
      </View>
    );
  }
}

type Props = StateProps & DispatchProps & { isLoading: boolean, route: NavigationScreenProp<NavigationRoute> };

export type StateProps = {
  roamingGroupCountries: CountryType[],
  roamingCountryId: ?string,
  roamingCountryZone: ?string,
  options: Option[],
  price: number,
  canBuy: boolean,
  isExemptedFromTax: boolean,
  isConfirmationLoading: boolean,
};

export type DispatchProps = {
  buy: Function,
  fetchRoamingBundles: Function,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'space-between',
    },
    planSummary: {
      marginVertical: 20,
    },
  });

export default withNavigation(RoamingPackage);
